import script from "./ManageMembers.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageMembers.vue?vue&type=script&setup=true&lang=js"

import "./ManageMembers.vue?vue&type=style&index=0&id=47df5834&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47df5834"]])

export default __exports__